/* eslint-disable no-console */
import type { PartialApiOptionsInterface, WsOptionsInterface } from './api-options';

interface ApiTypedPropertyDescriptor extends TypedPropertyDescriptor<any> {
  setOptions?: () => void;
  unsetOptions?: () => void;
}

/**
 * @internal
 */
export const ApiOptions = (options: PartialApiOptionsInterface): MethodDecorator => {
  return (...attrs) => {
    const descriptor: ApiTypedPropertyDescriptor = attrs[2];
    const originalMethod = descriptor.value;
    descriptor.value = function (...args: any[]) {
      if (!this['setOptions'] || typeof this['setOptions'] !== 'function') {
        console.error(new Error('you must define a setOptions() method'));
      } else {
        this['setOptions'](options);
      }
      return originalMethod.apply(this, args);
    };
    return descriptor;
  };
};

/**
 * @internal
 */
export const UnsetApiOptions = (): MethodDecorator => {
  return (...attrs) => {
    const descriptor: ApiTypedPropertyDescriptor = attrs[2];
    const originalMethod = descriptor.value;

    descriptor.value = function (...args: any[]) {
      const result = originalMethod.apply(this, args);
      if (!this['unsetOptions'] || typeof this['unsetOptions'] !== 'function') {
        console.error(new Error('you must define an unsetOptions() method'));
      } else {
        this['unsetOptions']();
      }
      return result;
    };
    return descriptor;
  };
};

/**
 * @internal
 */
export const WsOptions = (options: WsOptionsInterface): MethodDecorator => {
  return (...attrs) => {
    const descriptor: ApiTypedPropertyDescriptor = attrs[2];
    const originalMethod = descriptor.value;
    descriptor.value = function (...args: any[]) {
      if (!this['setOptions'] || typeof this['setOptions'] !== 'function') {
        console.error(new Error('you must define a setOptions() method'));
      } else {
        this['setOptions'](options);
      }
      return originalMethod.apply(this, args);
    };
    return descriptor;
  };
};

/**
 * @internal
 */
export const UnsetWsOptions = (): MethodDecorator => {
  return (...attrs) => {
    const descriptor: ApiTypedPropertyDescriptor = attrs[2];
    const originalMethod = descriptor.value;

    descriptor.value = function (...args: any[]) {
      const result = originalMethod.apply(this, args);
      if (!this['unsetOptions'] || typeof this['unsetOptions'] !== 'function') {
        console.error(new Error('you must define an unsetOptions() method'));
      } else {
        this['unsetOptions']();
      }
      return result;
    };
    return descriptor;
  };
};
